import React, { useState, useEffect, useRef } from 'react';
import { Grid, Chip, Typography, Button } from '@mui/material';
import { Alert } from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import {
  PageContainer,
  InputV2,
  ButtonLoading,
  AutocompleteV,
  HeaderSection,
  CustomPopover,
  InquiryAgentDg,
  InquiryOwnerDg,
  Icons,
  ProvinceCityListComponent,
} from 'components';

import { useGuildsList } from 'hooks';
import { validator } from 'myValidation';
import { checkContactDelegation } from '../../../DigitalAccount/ReceivedDelegationList/ReceivedDelegation/components/TransferDelegation/services/TransferDelegationServices';
import SubsetServices from '../../services/SubsetServices';
import { useStyles } from '../AddBranch/style';
import createToast from 'components/Toast/Toast';
import { constBreadCrumbsTitle } from 'utility';

export default function EditBranch() {
  const classes = useStyles();
  const methods = useForm();
  const params = useParams();
  const location = useLocation();
  const { branchInfo } = location?.state;
  const navigate = useNavigate();
  const { guildsList, getGuildsList, guildListLoading } = useGuildsList();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [userSSOid, setUserSSOid] = useState(0);
  const [city, setCity] = useState();
  const [province, setProvince] = useState();
  const [formData, setFormData] = useState(null);
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const [guildSearchText, setGuildSearchText] = useState('');
  const [agentFirstName, setAgentFirstName] = useState('');
  const [agentLastName, setAgentLastName] = useState('');
  const [selectedGuilds, setSelectedGuilds] = useState([]);
  const [isShowMessageLessLevel, setIsShowMessageLessLevel] = useState(false);
  const [dataEstelam, setDataEstelam] = useState(null);
  const [isLoadingOwnerDg, setIsLoadingOwnerDg] = useState(false);
  const [isOpenOwnerDg, setIsOpenOwnerDg] = useState(false);
  const [enteredCaptchaOwner, setEnteredCaptchaOwner] = useState('');
  const [captchaIdOwnerDg, setCaptchaIdOwnerDg] = useState(null);
  const [ownerValues, setOwnerValues] = useState({
    userContactInfo: '',
  });

  const [isLoadingAgentDg, setIsLoadingAgentDg] = useState(false);
  const [isOpenAgentDg, setIsOpenAgentDg] = useState(false);
  const [enteredCaptchaAgent, setEnteredCaptchaAgent] = useState('');
  const [captchaIdAgentDg, setCaptchaIdAgentDg] = useState(null);
  const [agentValues, setAgentValues] = useState({
    agentCellphoneNumber: '',
    agentNationalCode: '',
  });
  const [userContactInfoFLname, setUserContactInfoFLname] = useState('');
  const captachaOwnerRef = useRef();
  const captachaAgentRef = useRef();

  useEffect(() => {
    if (!selectedGuilds.length) {
      methods.setValue('guild', '');
    }
  }, [selectedGuilds]);

  useEffect(() => {
    if (
      methods.formState.errors &&
      Object.keys(methods.formState.errors).length > 0 &&
      methods.formState.submitCount > 0
    ) {
      createToast('خطا', errorsToStr(methods.formState.errors), 'danger');
    }
  }, [methods.formState.submitCount]);

  useEffect(() => {
    setLoading(true);

    if (!branchInfo) {
      SubsetServices.getBranch({ businessId: params.id, offset: 0, size: 1 })
        .then((res) => {
          const branchData = res.result[0];
          setAgentValues({
            agentCellphoneNumber: branchData?.agent?.cellphoneNumber || '',
            agentNationalCode: branchData?.agent?.nationalCode || '',
          });
          setUserContactInfoFLname(branchData?.owner?.name || '');
          setFormData(branchData);
          setProvince(branchData?.state);
          setFullName(
            branchData?.agent?.firstName
              ? branchData?.agent?.firstName + ' ' + branchData?.agent?.lastName
              : '',
          );
          setAgentFirstName(branchData?.agent?.firstName);
          setAgentLastName(branchData?.agent?.lastName);
          setCity(branchData?.city);
          setSelectedGuilds(branchData?.guilds);
          setLoading(false);

          if (branchData?.owner) {
            setUserSSOid(Number(branchData?.owner?.ssoId));
            methods.setValue('userContactInfoFLname', branchData?.owner?.name);
          }
        })
        .catch(() => {});
    } else {
      setFormData(branchInfo);
      setProvince(branchInfo?.state);
      setCity(branchInfo?.city);
      setSelectedGuilds(branchInfo?.guilds);
      setLoading(false);
      setUserSSOid(Number(branchInfo?.owner?.ssoId));
      methods.setValue('userContactInfoFLname', branchInfo?.owner?.name);
    }
    getGuildsList();
  }, []);

  useEffect(() => {
    methods.register('guildCode');
    methods.register('username');
    return () => {
      methods.unregister('guildCode');
      methods.unregister('username');
    };
  }, [methods, methods.register, methods.unregister]);

  const getBranchOwner = async () => {
    setIsShowMessageLessLevel(false);
    try {
      const contactInfo = methods.watch('userContactInfo').replace(/\s/g, '');
      const body = {
        captchaAnswer: enteredCaptchaOwner,
        captchaId: captchaIdOwnerDg,
      };

      if (validator.isEmail(contactInfo ?? '')) {
        body.email = contactInfo;
      } else if (validator.isMobilePhone(contactInfo ?? '')) {
        body.phoneNumber = contactInfo;
      } else if (validator.matches(contactInfo ?? '', /([A-Za-z0-9._-]){3,63}/)) {
        body.username = contactInfo;
      } else {
        createToast('خطا', 'تلفن ، ایمیل یا نام کاربری مالک معتبر نمی‌باشد.!', 'danger');
        methods.setValue('userContactInfoFLname', '');
        return;
      }
      methods.setValue('userContactInfoFLname', '');
      setIsLoadingOwnerDg(true);
      const data = await checkContactDelegation(body);
      setDataEstelam(data?.result);
      setUserSSOid(data?.result?.ssoId);

      if (data?.result?.given_name && data?.result?.family_name) {
        methods.setValue(
          'userContactInfoFLname',
          `${data?.result?.given_name} ${data?.result?.family_name}`,
        );
        setTimeout(() => {
          setUserContactInfoFLname(`${data?.result?.given_name} ${data?.result?.family_name}`);
        }, 100);
      } else {
        // سطح کمتر از 3

        setIsShowMessageLessLevel(true);
        setUserContactInfoFLname(' ');
        methods.setValue('userContactInfoFLname', ' ');
      }
      setIsLoadingOwnerDg(false);
      setIsOpenOwnerDg(false);
    } catch (error) {
      setIsLoadingOwnerDg(false);
      captachaOwnerRef?.current?.onMakeCaptcha();
    }
  };
  const getBranchAgent = async () => {
    try {
      const contactInfo = methods.watch('agentCellphoneNumber');
      const nationalCode = methods.watch('agentNationalCode');

      const body = {
        captchaAnswer: enteredCaptchaAgent,
        captchaId: captchaIdAgentDg,
      };

      if (nationalCode?.length > 0) {
        if (!validator.isNumeric(nationalCode ?? '')) {
          createToast('خطا', ' کد ملی نماینده باید عدد باشد.', 'danger');
          captachaAgentRef?.current?.onMakeCaptcha();
          return;
        } else if (nationalCode?.length !== 10) {
          createToast('خطا', ' کد ملی نماینده باید 10 رقم باشد.', 'danger');
          captachaAgentRef?.current?.onMakeCaptcha();

          return;
        }
      }
      if (validator.isMobilePhone(contactInfo ?? '')) {
        body.phoneNumber = contactInfo;
      } else {
        createToast('خطا', ' شماره همراه نماینده معتبر نمی‌باشد.!', 'danger');
        return;
      }
      setIsLoadingAgentDg(true);
      const data = await checkContactDelegation(body);
      if (data?.result?.given_name && data?.result?.family_name) {
        setAgentFirstName(data?.result?.given_name);
        setAgentLastName(data?.result?.family_name);
        setFullName(data?.result?.given_name + ' ' + data?.result?.family_name || '');
        methods.setValue(
          'agentFullName',
          `${data?.result?.given_name} ${data?.result?.family_name}`,
        );
      }
      setIsLoadingAgentDg(false);
      setIsOpenAgentDg(false);
    } catch (error) {
      captachaAgentRef?.current?.onMakeCaptcha();
      setIsLoadingAgentDg(false);
    }
  };

  const checkAgent = () => {
    const values = methods.getValues();
    if (
      (!fullName.trim() &&
        !agentValues.agentCellphoneNumber.trim() &&
        !agentValues.agentNationalCode.trim()) ||
      (fullName.trim() &&
        agentValues.agentCellphoneNumber.trim() &&
        agentValues.agentNationalCode.trim())
    ) {
      return true;
    } else {
      createToast('خطا', 'لطفا تمام فیلدهای اطلاعات نماینده شعبه را کامل نمایید', 'danger');

      return false;
    }
  };
  const onSubmit = async () => {
    const statusAgent = checkAgent();
    if (!statusAgent) return;

    const values = methods.getValues();
    const cityName = values.city?.label;
    const stateName = values.state?.label;
    const cityId = values.city?.id;
    const stateId = values.state?.id;
    if (values.state && !values.city) {
      createToast('خطا', 'لطفا شهر را وارد نمایید.', 'danger');

      return;
    }
    if (isShowMessageLessLevel && !dataEstelam?.given_name && !dataEstelam?.family_name) {
      createToast('خطا', 'سطح مالی مالک کسب و کار کافی نمی باشد.', 'danger');
      return;
    }
    const requestBody = {
      bizId: params.id,
      username: values.username,
      businessName: values.businessName,
      email: values.email,
      phone: values.phone,
      economicCode: values.economicCode,
      nationalCode: values.nationalCode,
      registrationNumber: values.registrationNumber,
      guildCode: selectedGuilds.map((g) => g.code),
      country: 'ایران',
      countryId: 1,
      state: stateName,
      stateId,
      city: cityName,
      cityId,
      address: values.address,
      description: values.description,
      changeAgent: true,
      sheba: values.sheba,
      ssoIdOwner: userSSOid,
    };

    for (let item in requestBody) {
      if (!requestBody[item]) {
        delete requestBody[item];
      }
    }

    requestBody['agentFirstName'] = agentFirstName || '';
    requestBody['agentLastName'] = agentLastName || '';
    requestBody['agentCellphoneNumber'] = agentValues.agentCellphoneNumber || '';
    requestBody['agentNationalCode'] = agentValues.agentNationalCode || '';
    setSubmitLoading(true);

    await SubsetServices[branchInfo ? 'updateSubSetBranch' : 'updateBranch'](requestBody)
      .then(() => {
        createToast('موفق', 'با موفقیت انجام شد', 'success');

        if (branchInfo) {
          navigate('/SubBusiness');
        } else {
          navigate('/Branch');
        }
      })
      .catch((error) => {})
      .finally(() => {
        setSubmitLoading(false);
      });
  };

  const removeSelectedGuilds = (id) => {
    setSelectedGuilds((state) => state.filter((g) => g.id !== id));
  };
  const errorsToStr = (errs) => {
    if (!errs) return null;
    return (
      <div>
        {Object.keys(errs).map((v) => (
          <li>{errs[v]?.message}</li>
        ))}
      </div>
    );
  };

  /**
   * زمانیکه دکمه اینتر کلیک شود، جلوی سابمیت و ارسال اطلاعات گرفته خواهد شد
   * @param {eventClick} e
   */
  const handleEnterClick = (e) => {
    if (e.key == 'Enter' && e.target?.localName != 'textarea') {
      e.preventDefault();
    }
  };

  //-- LOCAL VARIABLES--//

  const hintText =
    'کسب و کارهای تایید شده می‌توانند کسب و کارهای دیگر را به عنوان شعبه‌ی خود ثبت نمایند، به نحوی که کاربری و کسب و کار مجزا برای آن‌ها ایجاد گردد. لازم به ذکر است، کسب و کارهای ایجاد شده در صورت دریافت شماره شبا، از شناسه ملی کسب و کار اصلی استفاده می‌نمایند که فقط توسط کسب و کار اصلی قابل ویرایش می‌باشد و ویرایش اطلاعات اصلی (شبا) کسب و کار توسط کسب و کار شعبه امکان‌پذیر نیست.';

  return (
    <PageContainer
      title={branchInfo ? 'ویرایش زیر مجموعه' : 'ویرایش شعبه'}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.EDIT_BRNACH}
      loading={loading}
      meta={
        <Button
          color="primary"
          variant="outlined"
          endIcon={<Icons icon="CaretLeft" color="#2b3990" size="25" />}
          onClick={() => navigate('/Branch')}
        >
          بازگشت به لیست شعبه ها
        </Button>
      }
    >
      <FormProvider {...methods}>
        {!loading && formData && (
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            onKeyDown={(e) => {
              handleEnterClick(e);
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={3}>
              <Grid direction="row" spacing={3} container item xs={12} md={12} lg={6}>
                <Grid item xs={12}>
                  <HeaderSection title="اطلاعات پایه" />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label={branchInfo ? 'نام زیر مجموعه' : 'نام شعبه'}
                    name="businessName"
                    register={methods.register}
                    rules={['required', 'isLt|50', 'isNotContainTag']}
                    defaultValue={formData?.name}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="نام‌کاربری کسب‌و‌کار"
                    name="username"
                    register={methods.register}
                    rules={['required', 'isNotContainTag']}
                    defaultValue={formData?.username}
                    disabled
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="کد اقتصادی"
                    name="economicCode"
                    rules={['isNumeric', 'isEconomicCode']}
                    register={methods.register}
                    defaultValue={formData?.economicCode}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="شناسه ملی"
                    name="nationalCode"
                    register={methods.register}
                    rules={['isNumeric', 'isLength|11']}
                    defaultValue={formData?.nationalCode}
                  />
                </Grid>

                {!branchInfo && (
                  <>
                    <Grid item md={6} xs={12}>
                      <InputV2
                        fullWidth
                        errors={methods.formState.errors}
                        label="شماره ثبت"
                        name="registrationNumber"
                        register={methods.register}
                        defaultValue={formData?.registrationNumber}
                        rules={['isNumeric', 'isLt|7', 'isGt|3']}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      <InputV2
                        fullWidth
                        errors={methods.formState.errors}
                        label="شماره شبا"
                        name="sheba"
                        register={methods.register}
                        defaultValue={formData?.sheba}
                        rules={['isNumeric', 'isShebaAccount']}
                        startAdornment={<div style={{ marginInlineEnd: 10 }}>IR</div>}
                        dir="ltr"
                      />
                    </Grid>
                  </>
                )}

                {!branchInfo && (
                  <Grid item xs={12} md={12}>
                    <AutocompleteV
                      placeholder="جستجو و انتخاب کنید..."
                      control={methods.control}
                      errors={methods.formState.errors}
                      register={methods.register}
                      rules={['required']}
                      name="guild"
                      label="حسا‌ب‌های تفصیلی کسب‌وکار"
                      list={guildsList}
                      preventAddCustomOption
                      clearOn
                      loading={guildListLoading}
                      getOptionSelected={(option, value) => option.id === value.id}
                      getOptionDisabled={(option) =>
                        selectedGuilds.find((v) => v?.id === option?.id) != null
                      }
                      inputValue={guildSearchText}
                      onInputChange={(e) => {
                        setGuildSearchText(e?.target?.value ?? '');
                      }}
                      disableClearable
                      onChangeValue={(p) => {
                        setGuildSearchText('');
                        if (!p) return;
                        let temp = [...selectedGuilds];
                        temp.push(p);
                        setSelectedGuilds([...temp]);
                      }}
                      defaultValue={selectedGuilds}
                    />

                    <div style={{ marginTop: 10 }}>
                      {Array.isArray(selectedGuilds) &&
                        selectedGuilds.map((v, k) => (
                          <Chip
                            className={classes.chip}
                            key={k}
                            label={
                              <Typography style={{ fontSize: 12 }}>
                                {v?.id + '. ' + v?.name}
                              </Typography>
                            }
                            onClick={() => {}}
                            onDelete={() => removeSelectedGuilds(v?.id)}
                          />
                        ))}
                    </div>
                  </Grid>
                )}
                {branchInfo && (
                  <Grid item xs={12} md={12}>
                    <AutocompleteV
                      placeholder="جستجو و انتخاب کنید..."
                      errors={methods.formState.errors}
                      register={methods.register}
                      name="guild"
                      label="حسا‌ب‌های تفصیلی کسب‌وکار"
                      list={guildsList}
                      preventAddCustomOption
                      clearOn
                      loading={guildListLoading}
                      getOptionSelected={(option, value) => option.id === value.id}
                      getOptionDisabled={(option) =>
                        selectedGuilds.find((v) => v?.id === option?.id) != null
                      }
                      inputValue={guildSearchText}
                      onInputChange={(e) => {
                        setGuildSearchText(e?.target?.value ?? '');
                      }}
                      disableClearable
                      onChangeValue={(p) => {
                        setGuildSearchText('');
                        if (!p) return;
                        let temp = [...selectedGuilds];
                        temp.push(p);
                        setSelectedGuilds([...temp]);
                      }}
                      defaultValue={selectedGuilds}
                    />

                    <div style={{ marginTop: 10 }}>
                      {Array.isArray(selectedGuilds) &&
                        selectedGuilds.map((v, k) => (
                          <Chip
                            className={classes.chip}
                            key={k}
                            label={
                              <Typography style={{ fontSize: 12 }}>
                                {v?.id + '. ' + v?.name}
                              </Typography>
                            }
                            onClick={() => {}}
                            onDelete={() => removeSelectedGuilds(v?.id)}
                          />
                        ))}
                    </div>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <HeaderSection title="اطلاعات تماس" />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="ایمیل"
                    name="email"
                    rules={['isEmail']}
                    register={methods.register}
                    defaultValue={formData?.email}
                    dir="ltr"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputV2
                    fullWidth
                    errors={methods.formState.errors}
                    label="شماره تماس"
                    name="phone"
                    register={methods.register}
                    rules={['isNumeric', 'isLt|11']}
                    defaultValue={formData?.phone}
                  />
                </Grid>

                <ProvinceCityListComponent
                  methods={methods}
                  initialState={province}
                  initialCity={city}
                />
                <Grid item xs={12}>
                  <InputV2
                    label="آدرس"
                    fullWidth
                    errors={methods.errors}
                    name="address"
                    register={methods.register}
                    defaultValue={formData?.address}
                    rules={['required', 'isLt|250', 'isNotContainTag']}
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputV2
                    label="توضیحات"
                    multiline
                    fullWidth
                    rows={5}
                    errors={methods.formState.errors}
                    name="description"
                    register={methods.register}
                    defaultValue={formData?.description}
                    rules={['required', 'isNotContainTag']}
                  />
                </Grid>

                <Grid item xs={12}>
                  <label className={classes.titles}>
                    <span>*</span>اطلاعات مالک شعبه
                  </label>
                </Grid>
                {userContactInfoFLname ? (
                  <Grid item md={12} xs={12} className={classes.inquiryBox}>
                    <Grid item md={6} xs={12}>
                      <InputV2
                        fullWidth
                        errors={methods.formState.errors}
                        label="نام و نام‌خانوادگی "
                        name="userContactInfoFLname"
                        register={methods.register}
                        control={methods.control}
                        style={{ backgroundColor: 'rgb(239 239 239)' }}
                        disabled
                        forceValue={userContactInfoFLname}
                      />
                      {isShowMessageLessLevel && (
                        <span
                          style={{
                            position: 'absolute',
                            color: 'red',
                            fontSize: '11px',
                            marginTop: '-11px',
                          }}
                        >
                          سطح مالی مالک شعبه می بایست حداقل 3 باشد.
                        </span>
                      )}
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <ButtonLoading
                        type="button"
                        color="primary"
                        variant="outlined"
                        className={classes.btnChange}
                        onClick={() => {
                          setIsOpenOwnerDg(true);
                        }}
                        name={
                          <>
                            <span style={{ marginLeft: '5px', display: 'flex' }}>
                              <Icons icon="editPen" color="#303D8F" size="18" />
                            </span>
                            تغییر مالک
                          </>
                        }
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item md={12} xs={12} style={{ display: 'flex' }}>
                    <ButtonLoading
                      type="button"
                      color="primary"
                      variant="outlined"
                      style={{ width: '145px' }}
                      onClick={() => {
                        setIsOpenOwnerDg(true);
                      }}
                      name={
                        <>
                          <span style={{ marginLeft: '5px', display: 'flex' }}>
                            <Icons icon="plusCircle" color="#303D8F" size="18" />
                          </span>
                          افزودن مالک
                        </>
                      }
                    />

                    <Grid
                      style={{
                        marginRight: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        direction: 'ltr',
                        opacity: '0.8',
                      }}
                    >
                      <CustomPopover description="سطح مالی مالک شعبه می بایست حداقل 3 باشد." />
                    </Grid>
                  </Grid>
                )}

                <Grid item xs={12}>
                  {formData && formData?.unverifiedOwner ? (
                    <Alert severity="warning" className={classes.alert}>
                      <Icons icon="WarningTriangle" color="#E03E1A" size="28" />
                      <div className={classes.content}>
                        <h3 className={classes.title}>توجه</h3>
                        <p className={classes.textWrapper}>
                          «{formData?.unverifiedOwner?.name}» به عنوان مالک جدید ثبت شده است و در
                          حال بررسی و تایید توسط تیم پشتیبانی است.
                        </p>
                      </div>
                    </Alert>
                  ) : null}
                </Grid>

                <Grid item xs={12}>
                  <label className={classes.titles}>اطلاعات نماینده شعبه</label>
                </Grid>
                {fullName ? (
                  <Grid item md={12} xs={12} className={classes.inquiryBox}>
                    <Grid item md={6} xs={12}>
                      <InputV2
                        fullWidth
                        errors={methods.formState.errors}
                        label="نام و نام خانوادگی نماینده"
                        name="agentFullName"
                        control={methods.control}
                        register={methods.register}
                        style={{ backgroundColor: 'rgb(239 239 239)' }}
                        forceValue={fullName}
                        disabled
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <ButtonLoading
                        type="button"
                        color="primary"
                        variant="outlined"
                        className={classes.btnChange}
                        onClick={() => {
                          setIsOpenAgentDg(true);
                        }}
                        name={
                          <>
                            <span style={{ marginLeft: '5px', display: 'flex' }}>
                              <Icons icon="editPen" color="#303D8F" size="18" />
                            </span>
                            تغییر نماینده
                          </>
                        }
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item md={12} xs={12} style={{ display: 'flex' }}>
                    <ButtonLoading
                      type="button"
                      color="primary"
                      variant="outlined"
                      style={{ width: '145px' }}
                      onClick={() => {
                        setIsOpenAgentDg(true);
                      }}
                      name={
                        <>
                          <span style={{ marginLeft: '5px', display: 'flex' }}>
                            <Icons icon="plusCircle" color="#303D8F" size="18" />
                          </span>
                          افزودن نماینده
                        </>
                      }
                    />

                    <Grid
                      style={{
                        marginRight: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        direction: 'ltr',
                        opacity: '0.8',
                      }}
                    >
                      <CustomPopover description="سطح مالی نماینده شعبه می بایست حداقل 3 باشد." />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid direction="row" container item justifyContent="flex-end" xs={12}>
                <ButtonLoading
                  type="submit"
                  variant="contained"
                  color="primary"
                  loading={submitLoading}
                  disabled={submitLoading}
                  name="ثبت"
                />
              </Grid>
            </Grid>
          </form>
        )}
      </FormProvider>
      <InquiryOwnerDg
        isLoadingOwnerDg={isLoadingOwnerDg}
        setIsLoadingOwnerDg={setIsLoadingOwnerDg}
        isOpenOwnerDg={isOpenOwnerDg}
        setIsOpenOwnerDg={setIsOpenOwnerDg}
        enteredCaptchaOwner={enteredCaptchaOwner}
        setEnteredCaptchaOwner={setEnteredCaptchaOwner}
        captchaIdOwnerDg={captchaIdOwnerDg}
        setCaptchaIdOwnerDg={setCaptchaIdOwnerDg}
        captachaOwnerRef={captachaOwnerRef}
        methods={methods}
        getBranchOwner={getBranchOwner}
        ownerValues={ownerValues}
        setOwnerValues={setOwnerValues}
        userContactInfoFLname={userContactInfoFLname}
      />

      <InquiryAgentDg
        isLoadingAgentDg={isLoadingAgentDg}
        setIsLoadingAgentDg={setIsLoadingAgentDg}
        isOpenAgentDg={isOpenAgentDg}
        setIsOpenAgentDg={setIsOpenAgentDg}
        enteredCaptchaAgent={enteredCaptchaAgent}
        setEnteredCaptchaAgent={setEnteredCaptchaAgent}
        captchaIdAgentDg={captchaIdAgentDg}
        setCaptchaIdAgentDg={setCaptchaIdAgentDg}
        captachaAgetRef={captachaAgentRef}
        methods={methods}
        getBranchAgent={getBranchAgent}
        setAgentValues={setAgentValues}
        agentValues={agentValues}
        agentFullName={fullName}
      />
    </PageContainer>
  );
}
